const DEFAULTS = {
  triggerUrl: "#thread-colors",
};

/**
 * Hands the markup held in its <template> to a markup-modal whenever a link
 * anywhere on the page points at the configured anchor.
 *
 * <thread-colors-trigger modal-target="thread-colors-123" trigger-url="#thread-colors">
 *   <template data-content>…</template>
 * </thread-colors-trigger>
 */
class ThreadColorsTrigger extends HTMLElement {
  connectedCallback() {
    this.template = this.querySelector("template[data-content]");
    if (!this.template) return;

    this.handleClick = (e) => {
      const link = e.target.closest("a[href]");
      if (!link || !this._matches(link)) return;

      e.preventDefault();
      this._open(link);
    };

    // The modal is unreachable in the theme editor otherwise — there is nothing
    // on the page to click, and the section itself renders no visible markup.
    this.handleSelect = (e) => {
      if (!e.target.contains(this)) return;

      this._open(this);
    };

    this.handleDeselect = (e) => {
      if (!e.target.contains(this)) return;

      document.dispatchEvent(new CustomEvent("markup-modal:close"));
    };

    document.addEventListener("click", this.handleClick);
    document.addEventListener("shopify:section:select", this.handleSelect);
    document.addEventListener("shopify:section:deselect", this.handleDeselect);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleClick);
    document.removeEventListener("shopify:section:select", this.handleSelect);
    document.removeEventListener(
      "shopify:section:deselect",
      this.handleDeselect,
    );
  }

  _matches(link) {
    const trigger = this.triggerUrl;

    // Anchors are matched against the current page, so a link carrying the same
    // hash but pointing elsewhere still navigates rather than opening the modal.
    if (trigger.startsWith("#")) {
      return link.hash === trigger && link.pathname === window.location.pathname;
    }

    return link.href === new URL(trigger, window.location.href).href;
  }

  _open(opener) {
    opener.dispatchEvent(
      new CustomEvent("markup-modal:open", {
        bubbles: true,
        detail: {
          target: this.modalTarget,
          html: this.template.innerHTML,
        },
      }),
    );
  }

  get triggerUrl() {
    return this.getAttribute("trigger-url") || DEFAULTS.triggerUrl;
  }

  get modalTarget() {
    return this.getAttribute("modal-target");
  }
}

if (!customElements.get("thread-colors-trigger")) {
  customElements.define("thread-colors-trigger", ThreadColorsTrigger);
}
